<template>
  <div class="project">
    <div class="left-container">
      <p>I also have fun making vulgar logos or psychedelic art.</p>
      <div id="left-container">
        <div id="one" class="one"></div>
        <div id="two" class="one"></div>
      </div>
    </div>
    <div class="right-container">
      <div id="three" class="one"></div>
      <div id="four" class="one"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.project {
  width: 100%;
  height: 130vh;
  background: #000;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 15px;
}

.right-container {
  display: grid;
  place-items: center;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
}
.left-container {
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr;
}
#left-container {
  display: flex;
}

p {
  text-align: center;
  font-size: 50px;
  font-family: "Stalinist One", cursive;
  overflow: hidden;
  color: #4dba87;
  margin: 1px;
}

.one {
  height: 45vh;
  width: 45vh;
  margin: 0 10px 10px 10px;
}
#one {
  background: url("../assets/altceva.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
#two {
  background: url("../assets/inca-ceva.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
#three {
  background: url("../assets/doggy styles.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
#four {
  background: url("../assets/who.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
@media screen and (max-width: 600px) {
  .project {
    width: 100%;
    grid-template-columns: 1fr;
    height: 170vh;
  }
  #left-container {
    display: grid;
    place-items: center;
    grid-template-columns: 1fr;
    margin-top: -100px;
  }
  p {
    font-size: 35px;
  }
  .one {
    height: 55vh;
    width: 100%;
    margin: 0 10px 10px 10px;
  }
}
</style>
